// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2cKp9","title":"FrontImage_title__396Yu"};